import React from 'react'
import '../App.css';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
function Dashboard() {
  return (
    <div className="wrapper">
      <Sidebar />


      <div className="main">
        <Navbar />
        <main className="content">
          <div className="container-fluid p-0">
          </div>

        </main>
        <Footer />
      </div>

    </div>
  )
}

export default Dashboard
